module.exports = __webpack_public_path__ + "img/512.lighting.9eb7f1d0.svg";